// eslint-disable-next-line
// @ts-nocheck
import { ComponentType, PropsWithChildren } from 'react';

export * from './override-api-keys';

type OverridableFunction = (this: unknown, ...args: unknown[]) => unknown;

interface RCVOverrideAPI {
    overrideComponent: (
        overrideName: string,
        component: ComponentType<PropsWithChildren<unknown>>
    ) => RCVOverrideAPI;

    overrideFunction: (overrideName: string, func: OverridableFunction) => RCVOverrideAPI;

    enableOverrides: () => RCVOverrideAPI;
}

type INJECT_FUNCTION = (overridableApi: RCVOverrideAPI) => void;

let injectFunction: INJECT_FUNCTION = () => {
    // empty
};

export const setInjectFunction = (fun: INJECT_FUNCTION): void => {
    injectFunction = fun;
};

export const getInjectFunction = (): INJECT_FUNCTION => injectFunction;

let injectDependencies: any = {};

export const setDependencies = (dependencies: any): void => {
    injectDependencies = dependencies;
};

export const getDependencies = (): any => injectDependencies;
